.root {
  width: auto;
  min-width: 340px;
  max-width: 100%;
}

.content {
  overflow-y: auto;
}
